import { produce } from "immer";
import * as Actions from "./headerInfoActions";
import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = {
  byId: {},
  allIds: [],
  isLoading: false,
  errorMessage: null
};
const headerInfoReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_HEADER_INFO: {
      draft.isLoading = true;
      draft.errorMessage = null;
      break;
    }

    case Actions.FETCH_HEADER_INFO_SUCCESS: {
      const { email, data } = action.payload;

      const byId = {
        [email]: data
      };

      const allIds = [email];

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });

      draft.allIds = deepmerge(draft.allIds, allIds, {
        arrayMerge: combineMerge
      });

      draft.isLoading = false;
      break;
    }

    case Actions.FETCH_HEADER_INFO_FAILED: {
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorText;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default headerInfoReducer;
